<template>
	<div class="tab-body">
		<div class="dataTable autoFlex">
			<el-row>
				<el-col :span="16">
					<div id="rpt1" style="width:100%;height: 260px;"></div>
				</el-col>
				<el-col :span="8">
					<div id="rpt3" style="width:80%;height: 260px;top: 30px;"></div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<div id="rpt2" style="width:100%;height: 260px;top: 30px;"></div>
				</el-col>
				<el-col :span="4">
					<div id="rpt5" style="width:100%;height: 260px;top: 80px;"></div>
				</el-col>
				<el-col :span="8">
					<div id="rpt4" style="width:80%;height: 260px;top: 30px;"></div>
				</el-col>
			</el-row>
		</div>

	</div>
</template>
<script>

import * as echarts from 'echarts';

export default {
	name: 'exams',
	components: {
		echarts
	},
	data() {
		return {
		};
	},
	mounted() {
		//初始化第一个报表
		let echart1 = echarts.init(document.getElementById("rpt1"))
		let echart2 = echarts.init(document.getElementById("rpt2"))
		let echart3 = echarts.init(document.getElementById("rpt3"))
		let echart4 = echarts.init(document.getElementById("rpt4"))
		let echart5 = echarts.init(document.getElementById("rpt5"))

		let option1 = {
			title: {
				text: '旭景家园',
				subtext: '业委会委员投票' 
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'shadow'
				}
			},
			legend: {},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			xAxis: [
				{
					type: 'category',
					data: ['3#王洪峰', '4#付宝玉', '5#乐美磊', '6#李长锋', '7#肖爱民', '8#幸尹涛', '9#罗小艳', '10#郑敏芳', '11#郭容波', '12#梁茂贤', '13#彭尚英']

				}
			],
			yAxis: [
				{
					type: 'value'
				}
			],
			series: [
				{
					name: '12-16',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [552, 267, 283, 269, 453, 534, 473, 478, 439, 421, 478]
				},
				{
					name: '12-17',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [219, 57, 78, 88, 169, 211, 200, 195, 174, 160, 181]
				},
				{
					name: '12-18',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [144, 37, 42, 50, 121, 135, 129, 130, 118, 117, 126]
				},
				{
					name: '12-19',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [75, 20, 27, 26, 60, 74, 71, 62, 53, 53, 58]
				},
				{
					name: '12-20',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [76, 26, 31, 27, 60, 70, 65, 66, 57, 56, 56]
				},
				{
					name: '12-21',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [93, 39, 49, 38, 83, 92, 89, 79, 67, 64, 75]
				},
				{
					name: '12-22',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [45, 11, 19, 16, 42, 46, 42, 38, 34, 38, 42]
				},
				{
					name: '12-23',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [181, 79, 81, 87, 156, 168, 158, 151, 133, 123, 151]
				},
				{
					name: '12-24',
					type: 'bar',
					stack: 'Ad',
					emphasis: {
						focus: 'series'
					},
					data: [148,
65,
69,
64,
125,
143,
137,
127,
119,
102,
126,]
				}


			]
		};


		/////////////////////////////////////
		let option2 = {
			title: {
				text: '每日投票量'
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {
					type: 'cross',
					label: {
						backgroundColor: '#6a7985'
					}
				}
			},
			legend: {
				data: ['参与投票趋势']
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: ['12-16', '12-17', '12-18', '12-19', '12-20', '12-21', '12-22', '12-23', '12-24']
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
					type: 'line',
					stack: 'Total',
					label: {
						show: true,
						position: 'top'
					},
					areaStyle: {},
					emphasis: {
						focus: 'series'
					},
					data: [586, 235, 152, 81, 78, 105, 48, 201, 160],
					lineStyle: {
						normal: {
							color: 'red',
							type: 'solid',
							width: 1 //去掉连接线
						}
					}
				}

			]
		};

		////////////投票户数比///////////////
		let option3 = {
			title: {
				text: '两规投票户数比',
				subtext: '总2391户,已绑定:2050户',
				left: 'center',
				textStyle: {
					color: "red"
				}
			},
			series: [
				{
					name: 'Access From',
					type: 'pie',
					radius: '60%',
					data: [
						{ value: 1646, name: '已投票' },
						{ value: 404, name: '未投票' },
						{ value: 341, name: '未绑定' },

					],
					label: {
						position: "inside",
						show: true,
						formatter: `{d}%`,
						color: "#fff"
					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					},
					itemStyle: {
						normal: {
							color: function (colors) {
								var colorList = [
									'#ef6567',
									'#336633',
									'#FFCC66',
								];
								return colorList[colors.dataIndex];
							}
						}
					}
				}
			],tooltip: {
				trigger: 'item'
			},
			legend: {
				orient: 'vertical',
				left: 'left'
			},
		};
		///////////////////投票面积统计///////////////
		let option4 = {
			title: {
				text: '两规面积比',
				subtext: '总207153平,已绑定:180970平',
				left: 'center',
				textStyle: {
					color: "red"
				}
			},
			series: [
				{
					name: 'Access From',
					type: 'pie',
					radius: '60%',
					data: [
						{ value: 146600, name: '已投票' },
						{ value: 34310, name: '未投票' },
						{ value: 26183, name: '未绑定' },
					], label: {
						position: "inside",
						show: true,
						formatter: `{d}%`,
						color: "#fff"
					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					},
					itemStyle: {
						normal: {
							color: function (colors) {
								var colorList = [
									'#ef6567',
									'#336633',
									'#FFCC66',
								];
								return colorList[colors.dataIndex];
							}
						}
					}
				}
			]
		};
		///////////////////////////
		let option5 = {
			title: {
				text: '投票总共20天,第10天',
				textStyle: {
					color: "#CC0000"
				}
			},
			series: [
				{
					type: 'gauge',
					startAngle: 240,
					endAngle: 0,
					min: 0,
					max: 20,
					splitNumber: 2,
					itemStyle: {
						color: '#58D9F9',
						shadowColor: 'rgba(0,138,255,0.45)',
						shadowBlur: 10,
						shadowOffsetX: 2,
						shadowOffsetY: 2
					},
					progress: {
						show: true,
						roundCap: true,
						width: 18
					},
					pointer: {
						icon: 'path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z',
						length: '75%',
						width: 16,
						offsetCenter: [0, '5%']
					},
					axisLine: {
						roundCap: true,
						lineStyle: {
							width: 18
						}
					},
					axisTick: {
						splitNumber: 10,
						lineStyle: {
							width: 2,
							color: '#999'
						}
					},
					splitLine: {
						length: 12,
						lineStyle: {
							width: 3,
							color: '#999'
						}
					},
					axisLabel: {
						distance: 30,
						color: '#999',
						fontSize: 20
					},
					title: {
						show: false
					},
					detail: {
						backgroundColor: '#fff',
						borderColor: '#999',
						borderWidth: 0,
						width: '40%',
						height: 40,
						borderRadius: 8,
						offsetCenter: [45, '45%'],
						valueAnimation: true,
						formatter: function (value) {
							return '{value|' + (21 - value).toFixed(0) + '}{unit|天剩余}';
						},
						rich: {
							value: {
								fontSize: 30,
								fontWeight: 'bolder',
								color: '#CC0000'
							},
							unit: {
								fontSize: 20,
								color: '#CC0000',
								padding: [0, 0, -20, 10]
							}
						}
					},
					data: [
						{
							value: 10
						}
					]
				}
			]
		};

		echart1.setOption(option1);
		echart2.setOption(option2);
		echart3.setOption(option3);
		echart4.setOption(option4);
		echart5.setOption(option5);
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>

